import { Injectable } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";
import { HttpService } from "../http.service";
import { APIEndpoints } from "../../../config/apiEndpoint.config";
import { VerifyMftConnectionDto } from "../Models/write/VerifyMftConnectionDto";
import { VerifyB2BConnectionDto } from "../Models/write/VerifyB2BConnectionDto";

@Injectable({
  providedIn: "root",
})
export class AdminPanelVerifyMftConnectionService {
  headers: HttpHeaders;
  areaId: string;

  constructor(private httpService: HttpService) {
    this.headers = new HttpHeaders();
    this.headers.set("Content-Type", "application/json");
  }

  verifyMftConnection(data: VerifyMftConnectionDto) {
    return this.httpService.post(APIEndpoints.verifyMftConnection, data);
  }

  verifyB2BConnection(data: VerifyB2BConnectionDto) {
    return this.httpService.post(APIEndpoints.verifyB2BConnection, data);
  }
}
